var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 35,
    viewBox: "0 0 173 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65039 23.3759C1.65039 23.3759 8.35515 22.5829 15.9781 24.488C30.4764 28.1114 31.3035 21.4761 36.6796 18.2767C41.5982 15.3496 45.6717 17.1355 51.1482 20.7151C55.1873 23.3552 61.0738 27.787 67.1699 27.0735C72.7425 26.4213 76.6929 21.2236 84.417 19.9017C90.5388 18.854 95.5138 21.7322 102.563 20.7151C112.126 19.3354 116.398 11.2124 123.232 11.2124C131.668 11.2124 137.607 4.34229 145.281 4.34229C152.909 4.34229 153.945 8.38208 162.29 11.2124C168.669 13.3762 171.739 11.2124 171.739 11.2124V34.3991H1.65039V23.3759Z",
    fill: "url(#paint0_linear_69_4256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65039 19.7745C1.65039 19.7745 8.35515 18.9929 15.9781 20.8705C30.4764 24.4414 31.3035 17.9022 36.6796 14.7491C41.5982 11.8644 45.6717 13.6244 51.1482 17.1522C55.1873 19.7541 61.0738 24.1217 67.1699 23.4186C72.7425 22.7758 76.6929 17.6533 84.417 16.3505C90.5388 15.318 95.5138 18.1546 102.563 17.1522C112.126 15.7924 116.398 7.78703 123.232 7.78703C131.668 7.78703 137.607 1 145.281 1C152.909 1 153.315 4.99768 161.66 7.78703C168.039 9.91951 171.739 7.78703 171.739 7.78703",
    stroke: "#F59E0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_4256",
    x1: 32.3898,
    y1: 19.5933,
    x2: 32.3898,
    y2: 34.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.f8bf02135a95c5acb136f9ef217c2416.svg";
export { ForwardRef as ReactComponent };